export function method(_fn_) {
    // Explain that this is done in build-time
    return { fileName: '', functionName: '', __fn__: _fn_ };
}
export function route(_route_) {
    return _route_;
}
export function dsl(_dsl_) {
    return _dsl_;
}
//# sourceMappingURL=wrap.js.map